import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'

import { passwordReset } from 'store/actions/user'

const ResetPassword = () => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)
  const dispatch = useDispatch()

  const [email, setEmail] = useState('')
  const [emailValid, setEmailValid] = useState(false)
  const [emailError, setEmailError] = useState('')
  const [modalOpened, setModalOpened] = useState(false)

  const toggleModal = () => setModalOpened(!modalOpened)

  const handleEmailChange = e => {
    validateEmail(e.target.value)
    setEmail(e.target.value)
  }

  const validateEmail = input => {
    let isValid = true

    if (input === '') {
      setEmailError(t.user.fieldRequired)
      isValid = false
    }
    if (isValid) {
      setEmailError('')
    }
    setEmailValid(isValid)
  }

  const sendPasswordResetEmail = async () => {
    setEmailError('')
    const emailExists = await dispatch(passwordReset(email))

    if (emailExists) {
      toggleModal()
    } else {
      setEmailError(t.user.emailNotFound)
    }
  }

  const onEnter = e => {
    e.preventDefault()
    if (emailValid) {
      sendPasswordResetEmail()
    }
  }

  return (
    <div>
      <a className="reset-password-link" onClick={toggleModal}>
        {t.user.resetPassword}
      </a>
      <Dialog className="Reset-password-page__facets-dialog" open={modalOpened}>
        <DialogTitle>{t.user.resetPassword}</DialogTitle>
        <DialogContent>
          <p>{t.user.userNameOrEmail}</p>
          <form className="Login">
            <TextField
              variant="standard"
              placeholder={t.user.email}
              label={t.user.email}
              onChange={handleEmailChange}
              onKeyDown={e => (e.key === 'Enter' ? onEnter(e) : null)}
              error={!!emailError}
              helperText={emailError}
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button className="reset" disabled={!emailValid} onClick={sendPasswordResetEmail}>
            {t.user.resetPasswordSubmit}
          </Button>
          <Button onClick={toggleModal} variant="text">
            {t.global.close}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default ResetPassword
